import React, { useRef, useEffect } from "react";
import emailjs from '@emailjs/browser';
import "../Styles/booking.css";

const SERVICE_ID = "service_lb2umag";
const TEMPLATE_ID = "template_zn3lv5m";
const PUBLIC_KEY = "mmQMesgIEYIPXgqxb";
const TEMPLATE_CONFIRMATION_ID = "template_rz54bri";

const Booking = () => {
  const formRef = useRef();
  const locationRef = useRef();

  useEffect(() => {
    // Google Places Autocomplete removed. Location field remains for manual entry.
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Send booking inquiry to DJ TLynn
      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY);
      // Send confirmation email to the user
      // Helper to format time to 12-hour with AM/PM
      function formatTime12hr(timeStr) {
        if (!timeStr) return "";
        const [hour, minute] = timeStr.split(":");
        let h = parseInt(hour, 10);
        const ampm = h >= 12 ? "PM" : "AM";
        h = h % 12;
        if (h === 0) h = 12;
        return `${h}:${minute} ${ampm}`;
      }

      const startTimeRaw = formRef.current["startTime"] && formRef.current["startTime"].value ? formRef.current["startTime"].value : "";
      const endTimeRaw = formRef.current["endTime"] && formRef.current["endTime"].value ? formRef.current["endTime"].value : "";
      const startTime12 = formatTime12hr(startTimeRaw);
      const endTime12 = formatTime12hr(endTimeRaw);

      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_CONFIRMATION_ID,
        {
          email: formRef.current["email"].value,
          name: formRef.current["name"].value,
          contactMethod: formRef.current["contactMethod"].value,
          phone: formRef.current["phone"] ? formRef.current["phone"].value : '',
          whatsapp: formRef.current["whatsapp"] ? formRef.current["whatsapp"].value : '',
          date: formRef.current["date"].value,
          // time: startTime12 && endTime12 ? `${startTime12} - ${endTime12}` : startTime12 || endTime12,
          startTime: startTime12,
          endTime: endTime12,
          event: formRef.current["event"].value,
          details: formRef.current["details"].value,
          location: locationRef.current.value,
        },
        PUBLIC_KEY
      );
      alert("Thank you for your request! Your booking inquiry was sent successfully. A confirmation email has been sent to you.");
      formRef.current.reset();
    } catch (error) {
      alert("Sorry, there was an error sending your request. Please try again later.");
    }
  };

  const [contactMethod, setContactMethod] = React.useState("phone");
  return (
    <section className="booking">
      <div className="booking-container">
        <h1 className="booking-title">Book DJ TLynn</h1>
        <p className="booking-subtitle">
          Share your event details and let’s create an unforgettable experience.
        </p>
        <form className="booking-form" ref={formRef} onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name*</label>
            <input type="text" id="name" name="name" required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email*</label>
            <input type="email" id="email" name="email" required />
          </div>
          <div className="form-group">
            <label>Preferred Contact Method*</label>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <label>
                <input
                  type="radio"
                  name="contactMethod"
                  value="phone"
                  checked={contactMethod === "phone"}
                  onChange={() => setContactMethod("phone")}
                /> Phone
              </label>
              <label>
                <input
                  type="radio"
                  name="contactMethod"
                  value="whatsapp"
                  checked={contactMethod === "whatsapp"}
                  onChange={() => setContactMethod("whatsapp")}
                /> WhatsApp
              </label>
            </div>
          </div>
          {contactMethod === "phone" && (
            <div className="form-group">
              <label htmlFor="phone">Phone Number*</label>
              <input type="tel" id="phone" name="phone" required />
            </div>
          )}
          {contactMethod === "whatsapp" && (
            <div className="form-group">
              <label htmlFor="whatsapp">WhatsApp Number*</label>
              <input type="tel" id="whatsapp" name="whatsapp" required placeholder="WhatsApp number" />
            </div>
          )}
          <div className="form-group">
            <label htmlFor="event">Event Type*</label>
            <input type="text" id="event" name="event" required />
          </div>
          <div className="form-group">
            <label htmlFor="date">Event Date*</label>
            <input type="date" id="date" name="date" required />
          </div>
          <div className="form-group">
            <label htmlFor="startTime">Start Time (optional)</label>
            <input type="time" id="startTime" name="startTime" />
          </div>
          <div className="form-group">
            <label htmlFor="endTime">End Time (optional)</label>
            <input type="time" id="endTime" name="endTime" />
          </div>
          <div className="form-group">
            <label htmlFor="location">Event Location*   (City, State, Country If No Exact Address)</label>
            <input type="text" id="location" name="location" ref={locationRef} required placeholder="Enter event address" autoComplete="off" />
          </div>
          <div className="form-group">
            <label htmlFor="details">Additional Details</label>
            <textarea id="details" name="details" rows="4"></textarea>
          </div>
          <button type="submit" className="booking-btn">Submit</button>
        </form>
      </div>
    </section>
  );
};

export default Booking;
